import React, { useState, useEffect } from "react";

// Helper functions to get/set cookies
const setCookie = (name, value, days) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
};

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const [customize, setCustomize] = useState(false);
  const [preferences, setPreferences] = useState({
    functional: true,
    analytics: false,
    marketing: false,
  });

  useEffect(() => {
    const cookiePref = getCookie("cookiesPreference");
    if (!cookiePref) {
      setVisible(true);
    }
  }, []);

  const handleAcceptAll = () => {
    setPreferences({ functional: true, analytics: true, marketing: true });
    setCookie("cookiesPreference", JSON.stringify({ functional: true, analytics: true, marketing: true }), 365);
    setVisible(false);
  };

  const handleDecline = () => {
    setPreferences({ functional: true, analytics: false, marketing: false });
    setCookie("cookiesPreference", JSON.stringify({ functional: true, analytics: false, marketing: false }), 365);
    setVisible(false);
  };

  const handleSavePreferences = () => {
    setCookie("cookiesPreference", JSON.stringify(preferences), 365);
    setVisible(false);
    setCustomize(false);
  };

  const toggleCustomize = () => setCustomize(!customize);

  if (!visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "#f1f1f1",
        padding: "12px 20px",
        boxShadow: "0 -2px 5px rgba(0,0,0,0.1)",
        zIndex: 1000,
      }}
    >
      {!customize ? (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap" }}>
          <span style={{ fontSize: "14px", color: "#333", marginBottom: "8px" }}>
            We use cookies to store your preferences and improve your experience.
          </span>
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            <button
              onClick={handleAcceptAll}
              style={{
                backgroundColor: "#007BFF",
                color: "white",
                border: "none",
                padding: "8px 16px",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              Accept All
            </button>
            <button
              onClick={handleDecline}
              style={{
                backgroundColor: "#ccc",
                color: "#333",
                border: "none",
                padding: "8px 16px",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              Decline
            </button>
            <button
              onClick={toggleCustomize}
              style={{
                backgroundColor: "#fff",
                color: "#007BFF",
                border: "1px solid #007BFF",
                padding: "8px 16px",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              Customize
            </button>
          </div>
        </div>
      ) : (
        <div>
          <p style={{ fontSize: "14px", color: "#333" }}>Select your preferences:</p>
          <div style={{ display: "flex", gap: "15px", marginBottom: "10px", flexWrap: "wrap" }}>
            <label>
              <input
                type="checkbox"
                checked={preferences.functional}
                disabled
              /> Functional (Always enabled)
            </label>
            <label>
              <input
                type="checkbox"
                checked={preferences.analytics}
                onChange={(e) => setPreferences({ ...preferences, analytics: e.target.checked })}
              /> Analytics
            </label>
            <label>
              <input
                type="checkbox"
                checked={preferences.marketing}
                onChange={(e) => setPreferences({ ...preferences, marketing: e.target.checked })}
              /> Marketing
            </label>
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <button
              onClick={handleSavePreferences}
              style={{
                backgroundColor: "#007BFF",
                color: "white",
                border: "none",
                padding: "8px 16px",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              Save Preferences
            </button>
            <button
              onClick={() => setCustomize(false)}
              style={{
                backgroundColor: "#ccc",
                color: "#333",
                border: "none",
                padding: "8px 16px",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CookieBanner;
